// validators/any.ts
import { AbstractValidator } from "../types.mjs";
var AnyValidator = class extends AbstractValidator {
  validate(value) {
    return value;
  }
};
var any = new AnyValidator();
export {
  AnyValidator,
  any
};
//# sourceMappingURL=any.mjs.map
